import { createSlice } from "@reduxjs/toolkit";
import {
  getPermissionsService,
  getNotificationsInfoService,
  getNotificationsService,
  getStatisticsService,
  getAllContactUSerService,
  getDiscountCouponsService,
  createDiscountCodeService,
  getAdvertisementsService,
  getStoreInfoService,
  getAllgovernoratesService,
  getAreaByGovService,
  getShippingByIdService,
  getShippingService,
  createAdvertismentService,
} from "../services/general_service";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  isLoadingAction: false,
  permissions: [],
  notifications: [],
  metaNotifications: null,
  statistics: {},
  contactUserList: [],
  metaContactUser: null,
  discountCode: [],
  metaDiscountCode: null,
  advertisment: [],
  metaAdvertismentCode: null,
  storeInfo: null,
  generalNotifications: [],
  metaGeneralNotifications: null,
  governoratesList: [],
  areas: [],
  shippingOfArea: {},
  shippingList: [],
};

const slice = createSlice({
  name: "permissions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Using builder callback notation
    builder
      .addCase(getPermissionsService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.permissions = action.payload?.data?.data;
      })
      .addCase(getPermissionsService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getPermissionsService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getNotificationsService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.notifications = action.payload?.data?.data;
        state.metaNotifications = action.payload.data.meta.meta;
      })
      .addCase(getNotificationsService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getNotificationsService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getStatisticsService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.statistics = action.payload?.data?.data;
      })
      .addCase(getStatisticsService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getStatisticsService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getAllContactUSerService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.contactUserList = action.payload?.data?.data;
        state.metaContactUser = action.payload.data.meta.meta;
      })
      .addCase(getAllContactUSerService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getAllContactUSerService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getDiscountCouponsService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.discountCode = action.payload?.data?.data;
        state.metaDiscountCode = action.payload.data.meta.meta;
      })
      .addCase(getDiscountCouponsService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getDiscountCouponsService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getAdvertisementsService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.advertisment = action.payload?.data?.data;
        state.metaAdvertismentCode = action.payload.data.meta.meta;
      })
      .addCase(getAdvertisementsService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getAdvertisementsService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getStoreInfoService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.storeInfo = action.payload?.data?.data;
      })
      .addCase(getStoreInfoService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getStoreInfoService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getNotificationsInfoService.fulfilled, (state, action) => {
        console.log(action.payload?.data?.data);
        state.isLoading = false;
        state.generalNotifications = action.payload?.data?.data;
        state.metaGeneralNotifications = action.payload.data.meta.meta;
      })
      .addCase(getNotificationsInfoService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getNotificationsInfoService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getAllgovernoratesService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.governoratesList = action.payload?.data?.data;
        //   state.metaContactUser = action.payload.data.meta.meta;
      })
      .addCase(getAllgovernoratesService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getAllgovernoratesService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })

      .addCase(getAreaByGovService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.areas = action.payload?.data?.data;
        //   state.metaContactUser = action.payload.data.meta.meta;
      })
      .addCase(getAreaByGovService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getAreaByGovService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getShippingByIdService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.shippingOfArea = action.payload?.data?.data;
        //   state.metaContactUser = action.payload.data.meta.meta;
      })
      .addCase(getShippingByIdService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getShippingByIdService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getShippingService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.shippingList = action.payload?.data?.data;
      })
      .addCase(getShippingService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getShippingService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(createAdvertismentService.fulfilled, (state, action) => {
        state.isLoadingAction = false;
      })
      .addCase(createAdvertismentService.rejected, (state) => {
        state.isLoadingAction = false; // Corrected the property name
      })
      .addCase(createAdvertismentService.pending, (state) => {
        state.isLoadingAction = true; // Corrected the property name
      });
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const { } = slice.actions;
